import { useEffect, useState } from 'react';
import { buildWhatsAppUrl } from '../data/site';
import { Icon } from './Icon';

export function WhatsAppFloat() {
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const show = window.setTimeout(() => setShowBubble(true), 2000);
    const hide = window.setTimeout(() => setShowBubble(false), 10000);
    return () => { window.clearTimeout(show); window.clearTimeout(hide); };
  }, []);

  return (
    <div className="wa-float-wrap">
      {showBubble && !dismissed ? (
        <div className="wa-bubble" role="status">
          <button type="button" aria-label="Cerrar mensaje" onClick={() => setDismissed(true)}><Icon name="x" size={14} /></button>
          <strong>¿Necesitas orientación?</strong>
          <span>Conversemos por WhatsApp.</span>
        </div>
      ) : null}
      <a className="wa-float" href={buildWhatsAppUrl()} target="_blank" rel="noopener noreferrer" aria-label="Escribir a Corporación Indemniza por WhatsApp">
        <Icon name="whatsapp" size={43} />
      </a>
    </div>
  );
}
